/* ===========================================================
   1) Kielivalitsin: FI / UK / SE liput ilmoituspalkissa
   2) Koko ja tuotetyyppi tuotekortteihin (Europosters-tyyli)
   3) Tuotetiedot tuotesivulle
   Kaikki kolme kieliversiota: fi / en / sv
   =========================================================== */
(function () {
  var LOCALES = [
    {
      code: 'fi',
      prefix: '',
      name: 'Suomeksi',
      svg: '<svg viewBox="0 0 18 11" xmlns="http://www.w3.org/2000/svg">' +
           '<rect width="18" height="11" fill="#ffffff"/>' +
           '<rect y="4" width="18" height="3" fill="#003580"/>' +
           '<rect x="5" width="3" height="11" fill="#003580"/></svg>'
    },
    {
      code: 'en',
      prefix: '/en',
      name: 'In English',
      svg: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg">' +
           '<clipPath id="kjuk"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>' +
           '<rect width="60" height="30" fill="#00247d"/>' +
           '<path d="M0,0 L60,30 M60,0 L0,30" stroke="#ffffff" stroke-width="6"/>' +
           '<path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#kjuk)" stroke="#cf142b" stroke-width="4"/>' +
           '<path d="M30,0 v30 M0,15 h60" stroke="#ffffff" stroke-width="10"/>' +
           '<path d="M30,0 v30 M0,15 h60" stroke="#cf142b" stroke-width="6"/></svg>'
    },
    {
      code: 'sv',
      prefix: '/sv',
      name: 'Pa svenska',
      svg: '<svg viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg">' +
           '<rect width="16" height="10" fill="#006aa7"/>' +
           '<rect y="4" width="16" height="2" fill="#fecc00"/>' +
           '<rect x="5" width="2" height="10" fill="#fecc00"/></svg>'
    }
  ];

  /* Kehote naytetaan vain suomeksi ja englanniksi. */
  var LABELS = { fi: 'Change language', en: 'Vaihda kieltä', sv: '' };

  /* Maxijuliste: pysty 61 x 91,5 cm - vaaka 91,5 x 61 cm.
     KJ 27.8.2026: korjattu 61,5->61 - todellinen Shopify-data (variantin
     "Koko"-optio, esim. Linkin Park "61x91.5 cm") vahvistaa oikean koon;
     tama on vain viimeinen varakeino, jos tuotteelta puuttuisi Koko-optio. */
  var T = {
    fi: {
      portrait: '61 × 91,5 cm', landscape: '91,5 × 61 cm', type: 'Juliste',
      infoTitle: 'Tuotetiedot',
      rows: [
        ['Koko', null],
        ['Materiaali', 'Laadukas juliste­paperi 150–220 g/m²'],
        ['Lisenssi', 'Virallisesti lisensoitu tuote'],
        ['Huom.', 'Kehys ei sisälly toimitukseen']
      ]
    },
    en: {
      portrait: '61 × 91.5 cm', landscape: '91.5 × 61 cm', type: 'Poster',
      infoTitle: 'Product details',
      rows: [
        ['Size', null],
        ['Material', 'Quality poster paper 150–220 g/m²'],
        ['Licence', 'Officially licensed product'],
        ['Note', 'Frame not included']
      ]
    },
    sv: {
      portrait: '61 × 91,5 cm', landscape: '91,5 × 61 cm', type: 'Affisch',
      infoTitle: 'Produktinformation',
      rows: [
        ['Storlek', null],
        ['Material', 'Affischpapper av hög kvalitet 150–220 g/m²'],
        ['Licens', 'Officiellt licensierad produkt'],
        ['Obs', 'Ram ingår inte']
      ]
    }
  };

  function lang() {
    var p = window.location.pathname;
    if (/^\/en(\/|$)/.test(p)) return 'en';
    if (/^\/sv(\/|$)/.test(p)) return 'sv';
    return 'fi';
  }

  function barePath() {
    return window.location.pathname.replace(/^\/(en|sv)(?=\/|$)/, '') || '/';
  }

  /* Muotoilee tuotteen todellisen koon (Shopifyn "Koko"-optio, esim.
     "59.4×84.1 cm") kieliversion mukaiseksi tekstiksi. Palauttaa null,
     jos raakadataa ei ole - silloin kaydaan vanhaan pysty/vaaka-arvaukseen. */
  function realSize(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    if (!s || s.toLowerCase() === 'default title' || s.toLowerCase() === 'default') return null;
    s = s.replace(/\s*[x×X]\s*/, ' × ');
    if (lang() !== 'en') {
      s = s.replace(/\./g, ',');
    }
    return s;
  }

  /* ---------- 1. Kielivalitsin ---------- */
  function buildLang() {
    var bar = document.querySelector('.utility-bar');
    if (!bar || bar.querySelector('.kj-lang')) return;

    var now = lang();
    var path = barePath();
    var wrap = document.createElement('div');
    wrap.className = 'kj-lang';

    if (LABELS[now]) {
      var span = document.createElement('span');
      span.className = 'kj-lang__label';
      span.textContent = LABELS[now];
      wrap.appendChild(span);
    }

    for (var i = 0; i < LOCALES.length; i++) {
      var l = LOCALES[i];
      var a = document.createElement('a');
      a.className = 'kj-lang__flag';
      a.href = l.prefix + path + window.location.search;
      a.title = l.name;
      a.setAttribute('aria-label', l.name);
      if (l.code === now) a.setAttribute('aria-current', 'true');
      a.innerHTML = l.svg;
      wrap.appendChild(a);
    }
    bar.appendChild(wrap);
  }

  /* ---------- 2. Koko tuotekortteihin ---------- */
  function sizeLabel(w, h, raw) {
    var t = T[lang()];
    var size = realSize(raw) || (w > h ? t.landscape : t.portrait);
    return size + ' · ' + t.type;
  }

  function cardMeta(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.querySelector('.kj-meta')) continue;
      var img = c.querySelector('img');
      var head = c.querySelector('.card__content .card__heading');
      if (!head) continue;
      var raw = c.getAttribute('data-kj-size');
      var w = 0, h = 0;
      if (img) {
        w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
        h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
      }
      if (!raw && (!w || !h)) continue;
      var d = document.createElement('div');
      d.className = 'kj-meta';
      d.textContent = sizeLabel(w, h, raw);
      head.parentNode.insertBefore(d, head.nextSibling);
    }
  }

  /* ---------- 3. Tuotetiedot tuotesivulle ---------- */
  function productInfo() {
    var box = document.querySelector('.product__info-container');
    if (!box || box.querySelector('.kj-specs')) return;
    var raw = box.getAttribute('data-kj-size');
    var img = document.querySelector('.product__media img, .product-media-container img');
    var w = 0, h = 0;
    if (img) {
      w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
      h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    }
    if (!raw && (!w || !h)) return;

    var t = T[lang()];
    var size = realSize(raw) || (w > h ? t.landscape : t.portrait);
    var wrap = document.createElement('div');
    wrap.className = 'kj-specs';

    var title = document.createElement('h2');
    title.className = 'kj-specs__title';
    title.textContent = t.infoTitle;
    wrap.appendChild(title);

    var dl = document.createElement('dl');
    dl.className = 'kj-specs__list';
    for (var i = 0; i < t.rows.length; i++) {
      var dt = document.createElement('dt');
      dt.textContent = t.rows[i][0];
      var dd = document.createElement('dd');
      dd.textContent = t.rows[i][1] || size;
      dl.appendChild(dt);
      dl.appendChild(dd);
    }
    wrap.appendChild(dl);

    var anchor = box.querySelector('.product__description, product-form, .product-form');
    if (anchor) { anchor.parentNode.insertBefore(wrap, anchor.nextSibling); }
    else { box.appendChild(wrap); }
  }

  function run(root) {
    buildLang();
    cardMeta(root);
    productInfo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  window.addEventListener('load', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });

  if (window.MutationObserver) {
    var start = function () {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            if (muts[i].addedNodes[j].nodeType === 1) cardMeta(muts[i].addedNodes[j]);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
